export class ValidateAccessGrantRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "subjects",
            "baseName": "subjects",
            "type": "DataCatalogSubjectSet",
            "format": ""
        },
        {
            "name": "privileges",
            "baseName": "privileges",
            "type": "Array<DataCatalogPrivilege>",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "DataCatalogGrantScope",
            "format": ""
        },
        {
            "name": "validFrom",
            "baseName": "validFrom",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ValidateAccessGrantRequest.attributeTypeMap;
    }
    constructor() {
    }
}
